<template>
    <div class="clockPanel">
        <Clock :time="time" :size="size"/>
    </div>
</template>

<script>
import Clock from './Clock.vue';

export default {
    name: 'ClockPanel',
    components: {Clock},
    props: {
        time: {type: Date},
        size: {type: [String, Number], default: 700},
    },
}
</script>

<style scoped>
.clockPanel {
    height: 100%;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
